import axios from "axios"
import { awsBasePath } from "./_config"
import { imageObjConstructor } from "./_utils"

const structureResultData = ({
  id,
  title,
  url,
  rating,
  imageDetailTile,
  elevationM,
  distanceKm,
  difficulty,
  description,
  start,
  region,
  duration,
}) => ({
  databaseId: id,
  name: title,
  uri: url,
  summary: description,
  ratings: { overall: rating },
  difficulty: `${difficulty}`,
  distance: { value: distanceKm, unit: "km" },
  elevation: { value: elevationM, unit: "m" },
  images: {
    detailTile: imageObjConstructor(imageDetailTile),
  },
  start,
  region: { name: region },
  duration,
})

const RouteContentService = {
  getFilteredList: (params, { page, perPage } = {}, requestKey) =>
    axios({
      method: "post",
      url: `${awsBasePath}/es/route-filter`,
      data: {
        params,
        pagination: {
          page: page || 1,
          perPage: perPage || 10,
        },
      },
    })
      .then(response => {
        if (!response || !response.data || !response.data.items) {
          return
        }
        return {
          requestKey,
          items: response.data.items.map(structureResultData),
          page: response.data.page,
          perPage: response.data.perPage,
          total: response.data.total,
          pageCount: Math.ceil(response.data.total / response.data.perPage),
          firstIndex: (response.data.page - 1) * response.data.perPage,
          lastIndex: 0,
        }
      })
      .catch(error => console.log("Error in getFilteredList call: ", error)),
}
export default RouteContentService
